import { render, staticRenderFns } from "./outbox.vue?vue&type=template&id=4c27988a&scoped=true&"
import script from "./outbox.vue?vue&type=script&lang=js&"
export * from "./outbox.vue?vue&type=script&lang=js&"
import style0 from "./outbox.vue?vue&type=style&index=0&id=4c27988a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27988a",
  null
  
)

export default component.exports